const backendUrl = process.env.REACT_APP_BACKEND_URL;

const nonAuthRoutes = [
    'register',
    'login',
    'report_issues',
    'reset-password',
    'force-password-change',
    'force-username',
    'force-phonenumber',
    'create-your-team',
];

async function checkAccessToken() {
    const now = new Date().toISOString();
    let user = JSON.parse(localStorage.getItem('user'));

    if (!user?.token) {
        await delay(1000);
        user = JSON.parse(localStorage.getItem('user'));
    }
    return user?.token && user.expires > now ? user.token : null;
}

async function checkRefreshToken() {
    const now = new Date().toISOString();
    let userRefresh = JSON.parse(localStorage.getItem('userRefresh'));

    if (!userRefresh?.token) {
        await delay(1000);
        userRefresh = JSON.parse(localStorage.getItem('userRefresh'));
    }

    if (!userRefresh?.token) throw new Error('Refresh Token not Found');
    if (userRefresh?.expires <= now) {
        throw new Error('Token Expired');
    }
    return userRefresh.token;
}
export async function jwtCheck(reloadOnError = false) {
    try {
        const token = await checkAccessToken();
        if (token) return token;

        const refreshToken = await checkRefreshToken();
        const accessToken = await getToken({ refreshToken });

        return accessToken?.token;
    } catch (error) {
        console.log('JWT ERROR: ', error);
        if (!reloadOnError) {
            return;
        }
        const path = new URL(window.location.href).pathname?.replaceAll('/', '');
        if (path && !nonAuthRoutes.includes(path)) {
            localStorage.clear();
            window.location.reload(true);
        }
    }
}

const getToken = async (refreshToken) => {
    let response = await fetch(backendUrl + '/auth/refresh-tokens', {
        method: 'POST',
        body: JSON.stringify(refreshToken),
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
    });
    if (!response.ok) {
        var error = new Error('Error ' + response.status + ': ' + response.statusText);
        error.response = response;
        throw error;
    }
    let tokens = await response.json();
    setToken(tokens.access, tokens.refresh);
    return tokens.access;
};

export const setToken = (accessToken, refreshToken) => {
    try {
        const bufferMs = 30 * 1000; // to account for request delay
        const expires = new Date(new Date(accessToken.expires).getTime() - bufferMs).toISOString();
        localStorage.setItem(
            'user',
            JSON.stringify({
                token: accessToken.token,
                expires,
            })
        );
        localStorage.setItem('userRefresh', JSON.stringify(refreshToken));
    } catch (err) {
        console.error('setToken:', err);
        localStorage.setItem('user', JSON.stringify(accessToken));
        localStorage.setItem('userRefresh', JSON.stringify(refreshToken));
    }
};

function delay(ms) {
    return new Promise((res) => setTimeout(res, ms));
}
